// extracted by mini-css-extract-plugin
module.exports = {"root":"Link_root__2spVb","App":"Link_App__diIJ5","User":"Link_User__2YhSV","Inbox":"Link_Inbox__1VmuC","Link":"Link_Link__3GWKt"};